<template>

    <div class="col-lg-7 col-md-6 col-sm-12">

        <h2>
            Certifikater
        </h2>

        <p style="margin-bottom:40px">
            <!--Tekst kommer snart-->
        </p>

        <div class="row">

            <certificate
                title="Transport af foder"
                issuer="Fødevarestyrelsen"
                link="/static/images/pp_fodertransport_certifikat.pdf"
            />

            <certificate
                title="Transport af farligt gods (ADR)"
                issuer="Energistyrelsen"
                link="/static/images/pp_farligtgods_certifikat.png"
            />

            <certificate
                title="Bevis for Indsamleruddannelse"
                issuer="Miljøministeriet"
                link="/static/images/indsamleruddannelse.pdf"
            />

        </div>

    </div>

</template>

<script>
import Certificate from './certificate.vue'

export default {
    components: {
        Certificate
    }
}
</script>




// WEBPACK FOOTER //
// certificates.vue?2e6a43ff